import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ServiceHistoryService } from 'src/app/services/service-history.service';
import { TranslateService } from  '@ngx-translate/core';

@Component({
  selector: 'app-service-history-edit-dialog',
  templateUrl: './service-history-edit-dialog.component.html',
  styleUrls: ['./service-history-edit-dialog.component.css']
})
export class ServiceHistoryEditDialogComponent implements OnInit {
  singleservice:any;
  mileagevalue: any;
  mileageunit: any;
  serviceid: any;
  vin: any;
  constructor(private translationService: TranslateService ,public dialogRef: MatDialogRef<ServiceHistoryEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private serviceHistory :ServiceHistoryService ,private toastrService: ToastrService ,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.mileagevalue=this.data.singleservice.mileage.value;
    this.mileageunit=this.data.singleservice.mileage.unit;
    this.serviceid=this.data.singleservice.id;
    this.vin=this.data.vin;
  }

  close(): void {
    this.data.eventName = 'POPUP_CLOSE';
    this.dialogRef.close({ event: this.data });
    
  }
  updateServiceMileage()
  {
    if (this.validateVehicleInfo( this.mileagevalue, this.mileageunit)) {
      this.spinner.show();
      this.data.eventName = 'POPUP_OK';
     //  console.log('Update Mileage');
        this.serviceHistory.putServiceHistoryMileage(this.serviceid,this.mileagevalue, this.mileageunit,'')
        .subscribe(response => {
        //  console.log(response);
          this.singleservice = response;
          this.spinner.hide();  
          this.data.mileageUpdate=true;   
          this.dialogRef.close({ event: this.data }) 
          }, error => {
            if (error && error.status && (error.status === 404||error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503) && error.error) {
              this.spinner.hide();
              this.data.mileageUpdate=false;
              this.toastrService.warning(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.error'));
              this.dialogRef.close({ event: this.data })
          } else {
              this.spinner.hide();
              this.data.mileageUpdate=false;
              this.toastrService.error(this.translationService.instant('dimbo.i18n.message.record.error'), this.translationService.instant('dimbo.i18n.message.toastr.error'));
              this.dialogRef.close({ event: this.data })
          }
           
          });
       }
  }

  validateVehicleInfo( currentMileage, mileageUnit): boolean {
   
 
   // currentMileage
   if (!this.isPositiveInteger(currentMileage)) {
    // console.log('pls enter valid Mileage');  
     this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.CurrentMileage'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
       timeOut: 5000,
     });
     return false;
   }
 
   // mileageUnit validation
   if (!mileageUnit) {
  //   console.log('pls enter mileageUnit ');  
     this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.mileageUnit'), this.translationService.instant('dimbo.i18n.message.validation.error'),{
       timeOut: 5000,
     });
     return false;  
   }
   
   return true;
 
 }

 isPositiveInteger(n: any) {
  if(!n) {
    return false;
  } else {
    if (!n.trim()) {
      return false;
    }
  }
  return n >>> 0 === parseFloat(n);
}
}
